import {OFFERS_DATA_FETCHED,FILTER_CHANGED,CHANGE_DISPLAY_LISTING_FROM} from '../actionsTypes'
import Utils from '../../../../libs/Utils'

const initialState = {
    // productInfos : {
    //     image : appData.image,
    //     name : appData.title,
    //     rateAverage: appData.reviewsListObject.reviewListStatistics.rateAverage,
    //     rateNumber: appData.reviewsListObject.reviewListStatistics.total,
    //     soldBy : appData.soldBy,
    //     isPei: appData.isPei,
    //     eligibilityToPrivateSale:appData.eligibilityToPrivateSale,
    //     privateSalePrice: appData.privateSalePrice,
    //     crossedOutPrice: appData.crossedOutPrice,
    //     price: appData.price
    // },
    // isFullMkpOffer: appData.soldBy.toLowerCase() === 'mkp',
    offersData: null,
    // productEan: appData.productId,
    newOffers : [],
    reconditionnedOffers : [],
    selectedFilter: 'all',
    selectedOffers : [],
    view : '',
    selectedOfferId : '',
    displayOfferListFrom : '',
    winningOffer: null,
};


const marketplaceReducer = (state = initialState, action) => {
    switch (action.type) {
        case OFFERS_DATA_FETCHED:
            return {
                ...state,
                offersData: action.payload.offersData,
                selectedOffers : action.payload.offersData.items,
                newOffers : action.payload.newOffers,
                reconditionnedOffers : action.payload.reconditionnedOffers,
                winningOffer : action.payload.winningOffer,
            }
        case FILTER_CHANGED:
            return {
                ...state,
                selectedOffers : action.payload.selectedOffers,
                selectedFilter : action.payload.selectedFilter,
            }

        case CHANGE_DISPLAY_LISTING_FROM:
            appData.actionTrigger.dispatch({
                trigger: "chooseBoxClicked",
                payload: {}
            });
            return {
                ...state,
                displayOfferListFrom : 'productSheet'
            }
        default:
            return state;
    }

};

export default marketplaceReducer;